import $ from 'jquery';

let fieldsAreInitialized = false;

function setDeleteFileButtonsType(context) {
  const deleteFileButtons = context.querySelectorAll('.gform_delete_file');

  deleteFileButtons.forEach(function (button) {
    button.setAttribute('type', 'button');
  });
}

function changeFileUpload() {
  const multiFileUploads = document.querySelectorAll(
    '.gform_fileupload_multifile'
  );
  if (0 < multiFileUploads.length) {
    multiFileUploads.forEach(function (fileUpload) {
      const dropInstructions = fileUpload.querySelector(
        '.gform_drop_instructions'
      );

      if (dropInstructions) {
        dropInstructions.textContent = wp.i18n._x(
          'Drag and drop file to upload',
          'drag and drop instruction',
          'vtx'
        );
      }
    });
  }

  setDeleteFileButtonsType(document);
}

function observeFileUploadChanges() {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return;
        }

        if (node.matches('.gform_delete_file')) {
          node.setAttribute('type', 'button');
        }

        setDeleteFileButtonsType(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

$(document).on('gform_post_render', function () {
  fieldsAreInitialized = true;
  changeFileUpload();
});

// ON READY
window.addEventListener('load', function () {
  if (!fieldsAreInitialized) {
    changeFileUpload();
  }

  observeFileUploadChanges();
});
